import React, { useEffect } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useMsal } from '@azure/msal-react';
import { registerMsalLogout, unregisterMsalLogout } from './msalLogout.service';

/**
 * MSAL Logout Provider
 *
 * This component registers the MSAL logout callback so that non-React code
 * (like error handlers) can trigger a proper MSAL logout.
 *
 * It should be placed within the MSAL context (inside AzureAdAuth component).
 */
export const MsalLogoutProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { instance, accounts } = useMsal();

  useEffect(() => {
    // Register the logout callback
    const handleLogout = async () => {
      try {
        console.log('[MSAL Logout Provider] Executing logout');

        if (accounts.length > 0) {
          // Perform proper MSAL logout (same as clicking logout button)
          await instance.logoutRedirect({
            account: accounts[0],
            postLogoutRedirectUri: window.location.origin,
          });
        } else {
          // No accounts, just redirect to home
          console.warn('[MSAL Logout Provider] No accounts found, redirecting to home');
          window.location.href = '/';
        }
      } catch (error) {
        console.error('[MSAL Logout Provider] Logout error:', error);
        // Fallback: redirect to home
        window.location.href = '/';
      }
    };

    registerMsalLogout(handleLogout);

    // Cleanup on unmount
    return () => {
      unregisterMsalLogout();
    };
  }, [instance, accounts]);

  return <>{children}</>;
};
